
define('text!modules/T1App/edit/access/users/templates/userLayout.html',[],function () { return '<div class="w-box">\n  <div class="access-container"><!-- The Search & browse views render here--></div>\n</div>';});

